import { render } from "./FeShow.vue?vue&type=template&id=3c7c44c8"
import script from "./FeShow.vue?vue&type=script&lang=js"
export * from "./FeShow.vue?vue&type=script&lang=js"

import "./FeShow.vue?vue&type=style&index=0&id=3c7c44c8&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__